import { env } from './EnvironmentConfig';

export const APP_NAME = 'MTag';
export const API_BASE_URL = env.API_ENDPOINT_URL;
export const APP_PREFIX_PATH = '/app';
export const AUTH_PREFIX_PATH = '/auth';

export const THEME_CONFIG = {
	/* navCollapsed: false,
	sideNavTheme: SIDE_NAV_LIGHT,
	locale: 'en',
	navType: NAV_TYPE_SIDE,
	topNavColor: '#144881',
	headerNavColor: '',
	mobileNav: false,
	currentTheme: 'light' */

	navType: 'TOP',
	sideNavTheme: 'SIDE_NAV_LIGHT',
	navCollapsed: false,
	topNavColor: '#144881',
	headerNavColor: '',
	locale: 'en',
	currentTheme: 'light',
};
